<template>
<v-card v-resize="onResize" class="ma-2 pa-2">
  <v-card-text>
    <p class="text-center title pb-0 mb-0 font-weight-regular">Energy Distribution (kWh)</p>
  </v-card-text>
  <div id='powerSankey' style='height:500px; width:100%;'></div>
  <!-- <v-select
     class="my-0 py-0"
     :items="chartTypeOptionLabels"
     v-model="chartTypeOption"
     @change="chartTypeChange"
  ></v-select> -->
</v-card>
</template>
<script>
import shine from '@/components/plugins/echarts-theme-shine';
// import energyData from '@/assets/energyData.json';

export default{
  data: () => ({
    epcData: [],
    energy: [],
    powerSankey: null,
    chartTypeOption: 0,
    chartTypeOptionLabels: [{text:'By Meter Type',value:0},{text:'By Floor',value:1}],
    dataZoom: null,
    minDate: Date.parse('January 01, 2018'),
    maxDate: Date.parse('December 31, 2018'),
    msPerDay: 86400000,
    dateRange: [Date.parse('January 01, 2018'),Date.parse('December 31, 2018')],
    // startDate: '1/01/2019',
    // endDate: '12/31/2019',
    lowerDateString: '1/01/2018',
    upperDateString: '12/31/2018',
    MandPBreakdown: true,
    plugBreakdown: true,
    lightingBreakdown: true,
    kendedaBreakdown: true,
  }),
  methods: {
    getData: _.debounce(async function() {
      this.powerSankey.showLoading();
      let startDateFullString = this.baseYear.toString().concat('-01-01 00:00:00')
      let endDateFullString = this.baseYear.toString().concat('-12-31 23:00:00')
      let buildingType = this.buildingType;
      if(buildingType == 'Residential'){
        buildingType = 'Single-family'
      }else if(buildingType == 'Educational'){
        buildingType = 'Academic'
      }
      let hashString = buildingType
      let seed = Math.floor(Math.random() * 10).toString()
      let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed
      for (let i = 0, ch; i < hashString.length; i++) {
        ch = hashString.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
      }
      h1 = Math.imul(h1 ^ (h1>>>16), 2246822507) ^ Math.imul(h2 ^ (h2>>>13), 3266489909);
      h2 = Math.imul(h2 ^ (h2>>>16), 2246822507) ^ Math.imul(h1 ^ (h1>>>13), 3266489909);
      let hash = (4294967296 * (2097151 & h2) + (h1>>>0)).toString(16).substr(-8)
      try {
        const url = 'https://fm-energywatch.ad.gatech.edu/rbsBackend/epc'
        //const url = 'http://localhost:8080/api/epc'
        //const url = 'http://localhost:8080/api/dtw' // for testing purposed (temporary)
        const bdata = {"hash":hash, "start":startDateFullString, "end":endDateFullString, "Usage":this.usage, "Location": this.location.split(',')[0], "Type": buildingType}
        const fetch_param = {
          method: 'POST',
          body: JSON.stringify(bdata),
          headers: {"Content-type": "application/json"}
        }
        console.log(JSON.stringify(bdata))
        const response = await fetch(url, fetch_param)
        const data = await response.json()
        console.log(data)
        this.epcData = data;
        console.log(this.epcData[0].DateTime)
        console.log("retrieved new data")
      } catch (error) {
        console.log(error)
      }
      this.powerSankey.hideLoading();
      this.refreshPowerSankey();
    },100),
    chartTypeChange(){
      this.refreshPowerSankey();
    },
    getDateRange(){
      //console.log(this.minDate)
      let d = new Date(this.dateRange[0]);
      this.lowerDateString = d.toLocaleDateString();
      d = new Date(this.dateRange[1]);
      this.upperDateString = d.toLocaleDateString();
      this.refreshPowerSankey();
    },
    toggleData(params){
      if(params.data.name=='Lighting'){
        this.lightingBreakdown=!this.lightingBreakdown;
        this.refreshPowerSankey();
      }else if(params.data.name=='Plug'){
        this.plugBreakdown=!this.plugBreakdown;
        this.refreshPowerSankey();
      }else if(params.data.name=='Mechanical\n&\nPlumbing'){
        this.MandPBreakdown=!this.MandPBreakdown;
        this.refreshPowerSankey();
      }else if(params.data.name=='Energy\nDemand'){
        this.kendedaBreakdown=!this.kendedaBreakdown;
        this.refreshPowerSankey();
      }
    },
    changeDataZoom(){
      this.$store.commit('changeDates',this.dataZoom.getOption());
      this.getEnergyTotals();
      this.refreshPowerSankey();
    },
    onResize() {
      if(this.powerSankey) _.debounce(this.powerSankey.resize, 100)()
    },
    getEnergyTotals(){
      let sqftTom2 = 0.0929; //conversion from square feet to m^2
      let energyTotals = {
        pv: this.grossArea*sqftTom2/1000*this.filterData.reduce((total,arr)=>total+this.solarArrayKfactor*arr.Egen_pv,0), //kWh
        // energyDemand: this.grossArea*sqftTom2/1000*this.filterData.reduce((total,arr)=>total+1*arr.EDemand,0), //kwh
        heating: this.grossArea*sqftTom2/1000*this.filterData.reduce((total,arr)=>total+1*arr.Eheat,0), //kwh
        cooling: this.grossArea*sqftTom2/1000*this.filterData.reduce((total,arr)=>total+1*arr.Ecool,0), //kWh
        waterHeating: this.grossArea*sqftTom2/1000*this.filterData.reduce((total,arr)=>total+1*arr.Edhw,0), //kWh
        // waterTreatment: this.filterData.reduce((total,arr)=>total+arr.WaterTreatmentkWh,0), //kWh
        fans: this.grossArea*sqftTom2/1000*this.filterData.reduce((total,arr)=>total+1*arr.Efan,0),
        pumps: this.grossArea*sqftTom2/1000*this.filterData.reduce((total,arr)=>total+1*arr.Epump,0),
        // battery: this.filterData.reduce((total,arr)=>total+arr.battery,0),
        // interiorLights: this.filterData.reduce((total,arr)=>total+this.lightbulbKfactor*arr.InteriorLightingkWh,0),
        // exteriorLights: this.filterData.reduce((total,arr)=>total+this.lightbulbKfactor*arr.ExteriorLightingkWh,0),
        lights: this.grossArea*sqftTom2/1000*this.filterData.reduce((total,arr)=>total+this.lightbulbKfactor*arr.Elight,0),
        // elevator: this.filterData.reduce((total,arr)=>total+arr.elevator,0),
        plug: this.grossArea*sqftTom2/1000*this.filterData.reduce((total,arr)=>total+1*arr.Eequip,0),
        // makerSpace: this.filterData.reduce((total,arr)=>total+arr.MakerkWh,0),
        // computerServices: this.filterData.reduce((total,arr)=>total+arr.ComputerServiceskWh,0),
        // coffeeCart: this.filterData.reduce((total,arr)=>total+arr.CoffeeCartkWh,0),
      };
      
      energyTotals.energyDemand = Object.values(energyTotals).reduce((total,type)=>total+type,0) - energyTotals.pv, //kwh

      this.energy.totals = energyTotals;

      // this.energy.totals.kendedaEnergy = Object.values(this.energy.totals).reduce((type,sum)=>sum+type)-this.energy.totals.pv;//-this.energy.totals.kendedaEnergy-this.energy.totals.basement-this.energy.totals.firstFloor-this.energy.totals.secondFloor-this.energy.totals.rooftop;
      // this.energy.totals.basement = 0.22*this.energy.totals.kendedaEnergy;
      // this.energy.totals.firstFloor = 0.26*this.energy.totals.kendedaEnergy;
      // this.energy.totals.secondFloor = 0.32*this.energy.totals.kendedaEnergy;
      // this.energy.totals.rooftop = 0.2*this.energy.totals.kendedaEnergy;
    },
    refreshPowerSankey() {
      // this.powerSankey.showLoading();
      console.log('getting energy totals')
      this.getEnergyTotals();
      console.log('got energy totals')
      let powerSankeyOption = {
          // title: {
          //   left: 'center',
          //   text: 'Energy Distribution (kWh)',
          // },
          tooltip: {
            trigger: 'item',
            triggerOn: 'mousemove'
          },
          grid: {
            containLabel: true,
            x: 10, x2: 10,
            y: 10, y2: 10,
          },
          series: [
          {
            type: 'sankey',
            // top: 15,
            // focusNodeAdjacency: 'allEdges',
            nodeAlign: 'left',
            layoutIterations: 0,
            lineStyle: {
                normal: {
                    color: 'source',
                    // curveness: 0.5
                }
            },
            // data from MV Tables 2-28-19 rev0
            data: this.sankeyData(),
            links: this.sankeyLinks(),
            // animation: true,
          },
        ],
        // animation: true,
      };
      if(Math.round(this.energy.totals.pv - this.energy.totals.energyDemand)>0){
        powerSankeyOption.series[0].links.push({source: 'Solar\nPanels', target: 'To Grid', value: Math.round(this.energy.totals.pv - this.energy.totals.energyDemand)});
        powerSankeyOption.series[0].links.unshift({source: 'Solar\nPanels', target: 'Energy\nDemand', value: Math.round(this.energy.totals.energyDemand)});
        powerSankeyOption.series[0].data[powerSankeyOption.series[0].data.length-1].name = 'To Grid';
      }else if(Math.round(this.energy.totals.pv - this.energy.totals.energyDemand)<0){
        powerSankeyOption.series[0].links.push({source: 'From Grid', target: 'Energy\nDemand', value: Math.round(this.energy.totals.energyDemand-this.energy.totals.pv)});
        powerSankeyOption.series[0].links.unshift({source: 'Solar\nPanels', target: 'Energy\nDemand', value: Math.round(this.energy.totals.pv)});
        powerSankeyOption.series[0].data[powerSankeyOption.series[0].data.length-1].name = 'From Grid';
      }else{
        powerSankeyOption.series[0].links.push({source: 'Solar\nPanels', target: 'Energy\nDemand', value: 0, linestyle: {opacity: 0}});
      }
      // console.log(powerSankeyOption)
      // this.powerSankey.hideLoading();
      this.powerSankey.setOption(powerSankeyOption);
    },
    sankeyData: function() {
      //let kendedaEnergy = this.energy.totals.heating+this.energy.totals.waterHeating+this.energy.totals.fans+this.energy.totals.pumps+this.energy.totals.plugOther+this.energy.totals.makerSpace+this.energy.totals.coffeeCart+this.energy.totals.computerServices+this.energy.totals.interiorLights+this.energy.totals.exteriorLights+this.energy.totals.elevator+this.energy.totals.battery;
      // let data = [];
      // console.log(this.energy.totals)
      // if(this.chartTypeOption==0){
      let data = [
          {name: 'Solar\nPanels', value: Math.round(this.energy.totals.pv), itemStyle:{color:'#C7A754'}},
          {name: 'Energy\nDemand', value: Math.round(this.energy.totals.energyDemand), itemStyle: {color:'#004D8C'}},
          {name: 'Mechanical\n&\nPlumbing', value: Math.round(this.energy.totals.heating+this.energy.totals.cooling+this.energy.totals.waterHeating+this.energy.totals.fans+this.energy.totals.pumps),itemStyle: {color: '#85503A'}},
          {name: 'Heating', value: Math.round(this.energy.totals.heating),itemStyle: {color: '#85503A'}},
          {name: 'Cooling', value: Math.round(this.energy.totals.cooling),itemStyle: {color: '#85503A'}},
          {name: 'Hot Water', value: Math.round(this.energy.totals.waterHeating),itemStyle: {color: '#85503A'}},
          {name: 'Fans', value: Math.round(this.energy.totals.fans),itemStyle: {color: '#85503A'}},
          {name: 'Pumps', value: Math.round(this.energy.totals.pumps),itemStyle: {color: '#85503A'}},
          {name: 'Plug', value: Math.round(this.energy.totals.plug),itemStyle: {color: '#6B983C'}},
          {name: 'Lighting', value: Math.round(this.energy.totals.lights),itemStyle: {color: '#594866'}},
          // {name: 'Water\nTreatment', value: Math.round(this.energy.totals.waterTreatment),itemStyle: {color: '#85503A'}},
          // {name: 'Lab Spaces', value: Math.round(this.energy.totals.makerSpace),itemStyle: {color: '#6B983C'}},
          // {name: 'Food & Beverage', value: Math.round(this.energy.totals.coffeeCart),itemStyle: {color: '#6B983C'}},
          // {name: 'Computer\nServices', value: Math.round(this.energy.totals.computerServices),itemStyle: {color: '#6B983C'}},
          // {name: 'Miscellaneous', value: Math.round(this.energy.totals.plugOther),itemStyle: {color: '#6B983C'}},
          // {name: 'Interior\nLighting', value: Math.round(this.energy.totals.interiorLights),itemStyle: {color: '#594866'}},
          // {name: 'Exterior\nLighting', value: Math.round(this.energy.totals.exteriorLights),itemStyle: {color: '#594866'}},
          // {name: 'Elevator', value: Math.round(this.energy.totals.elevator)},
          // {name: 'Battery Panel', value: Math.round(this.energy.totals.battery)},
          {name: 'Campus\nGrid', value: Math.abs(Math.round(this.energy.totals.pv - this.energy.totals.energyDemand)),itemStyle: {color: '#613F31'}}
      ];
      if (!this.MandPBreakdown){
        data = data.filter(e => e.name !== 'Heating' && e.name !== 'Hot Water' && e.name !== 'Fans' && e.name !== 'Pumps' && e.name !== 'Cooling');
      };
      if(this.buildingType == 'Residential'){
        data.splice(-1,0,{name: 'Laundry', value: Math.round(this.energy.totals.plug*0.5), itemStyle: {color: '#6B983C'}},
          {name: 'Kitchen Use', value: Math.round(this.energy.totals.plug*0.33), itemStyle: {color: '#6B983C'}},
          {name: 'Entertainment', value: Math.round(this.energy.totals.plug*0.17), itemStyle: {color: '#6B983C'}}
        );
      }
        // if (!this.plugBreakdown){
        //   data = data.filter(e => e.name !== 'Lab Spaces' && e.name !== 'Food & Beverage' && e.name !== 'Computer\nServices' && e.name !== 'Miscellaneous');
        // };
        // if (!this.lightingBreakdown){
        //   data = data.filter(e => e.name !== 'Interior\nLighting' && e.name !== 'Exterior\nLighting');
        // };
        // if (!this.kendedaBreakdown){
        //   data = data.filter(e => e.name == 'Solar\nPanels' || e.name == 'Energy\nDemand' || e.name == 'Campus\nGrid');
        // }
      // }else if(this.chartTypeOption==1){
      //   data = [
      //     {name: 'Solar\nPanels', value: Math.round(this.energy.totals.pv), itemStyle:{color:'#FCCC4A'}},
      //     {name: 'Energy\nDemand', value: Math.round(this.energy.totals.kendedaEnergy), itemStyle: {color:'#303F9F'}},
      //     {name: 'Basement', value: Math.round(this.energy.totals.basement),itemStyle: {color: '#582630'}},
      //     {name: 'First\nFloor', value: Math.round(this.energy.totals.firstFloor),itemStyle: {color: '#DB3A34'}},
      //     {name: 'Second\nFloor', value: Math.round(this.energy.totals.secondFloor),itemStyle: {color: '#7FC6A4'}},
      //     {name: 'Rooftop', value: Math.round(this.energy.totals.rooftop),itemStyle: {color: '#B0ACAB'}},
      //     {name: 'Campus\nGrid', value: Math.abs(Math.round(this.energy.totals.pv - this.energy.totals.kendedaEnergy)),itemStyle: {color: '#8A7029'}}
      //   ];
      //   if (!this.kendedaBreakdown){
      //     data = data.filter(e => e.name == 'Solar\nPanels' || e.name == 'Energy\nDemand' || e.name == 'Campus\nGrid');
      //   }
      // }
      return data;
    },
    sankeyLinks: function(){
      //let kendedaEnergy = this.energy.totals.heating+this.energy.totals.waterHeating+this.energy.totals.fans+this.energy.totals.pumps+this.energy.totals.plugOther+this.energy.totals.makerSpace+this.energy.totals.coffeeCart+this.energy.totals.computerServices+this.energy.totals.interiorLights+this.energy.totals.exteriorLights+this.energy.totals.elevator+this.energy.totals.battery;
      // if(this.chartTypeOption==0){
      let  links = [
          {source: 'Solar\nPanels', target: 'Energy\nDemand', value: Math.round(this.energy.totals.energyDemand)},
          {source: 'Energy\nDemand', target: 'Plug', value: Math.round(this.energy.totals.plug)},
          {source: 'Energy\nDemand', target: 'Lighting', value: Math.round(this.energy.totals.lights)},
          {source: 'Energy\nDemand', target: 'Mechanical\n&\nPlumbing', value: Math.round(this.energy.totals.heating+this.energy.totals.cooling+this.energy.totals.waterHeating+this.energy.totals.fans+this.energy.totals.pumps)},
          // {source: 'Kendeda', target: 'Elevator', value: Math.round(this.energy.totals.elevator)},
          // {source: 'Kendeda', target: 'Battery Panel', value: Math.round(this.energy.totals.battery)},
          {source: 'Mechanical\n&\nPlumbing', target: 'Heating', value: Math.round(this.energy.totals.heating)},
          {source: 'Mechanical\n&\nPlumbing', target: 'Cooling', value: Math.round(this.energy.totals.cooling)},
          {source: 'Mechanical\n&\nPlumbing', target: 'Hot Water', value: Math.round(this.energy.totals.waterHeating)},
          {source: 'Mechanical\n&\nPlumbing', target: 'Fans', value: Math.round(this.energy.totals.fans)},
          {source: 'Mechanical\n&\nPlumbing', target: 'Pumps', value: Math.round(this.energy.totals.pumps)},
          // {source: 'Mechanical\n&\nPlumbing', target: 'Water\nTreatment', value: Math.round(this.energy.totals.waterTreatment)},
          // {source: 'Plug', target: 'Lab Spaces', value: Math.round(this.energy.totals.makerSpace)},
          // {source: 'Plug', target: 'Food & Beverage', value: Math.round(this.energy.totals.coffeeCart)},
          // {source: 'Plug', target: 'Computer\nServices', value: Math.round(this.energy.totals.computerServices)},
          // {source: 'Plug', target: 'Miscellaneous', value: Math.round(this.energy.totals.plugOther)},
          // {source: 'Lighting', target: 'Interior\nLighting', value: Math.round(this.energy.totals.interiorLights)},
          // {source: 'Lighting', target: 'Exterior\nLighting', value: Math.round(this.energy.totals.exteriorLights)}
      ];
      if(this.buildingType == 'Residential'){
        links.push({source: 'Plug', target: 'Laundry', value: Math.round(this.energy.totals.plug*0.5)},
          {source: 'Plug', target: 'Kitchen Use', value: Math.round(this.energy.totals.plug*0.33)},
          {source: 'Plug', target: 'Entertainment', value: Math.round(this.energy.totals.plug*0.17)}
        );
      }
      // }else if(this.chartTypeOption==1){
      //   links = [
      //     {source: 'Solar\nPanels', target: 'Energy\nDemand', value: Math.round(this.energy.totals.kendedaEnergy)},
      //     {source: 'Energy\nDemand', target: 'Basement', value: Math.round(this.energy.totals.basement)},
      //     {source: 'Energy\nDemand', target: 'First\nFloor', value: Math.round(this.energy.totals.firstFloor)},
      //     {source: 'Energy\nDemand', target: 'Second\nFloor', value: Math.round(this.energy.totals.secondFloor)},
      //     {source: 'Energy\nDemand', target: 'Rooftop', value: Math.round(this.energy.totals.rooftop)},
      //   ];
      // }
      return links;
    },
  },
  watch: {
    // energyData: function() {
    //   this.refreshPowerSankey();
    // },
    startDate: function(newDates,oldDates){
      this.refreshPowerSankey();
    },
    endDate: function(newDates,oldDates){
      this.refreshPowerSankey();
    },
    selectedTimes: function(newTimes,oldTimes){
      this.refreshPowerSankey();
    },
    solarArrayKfactor: function(newKfactor,oldKfactor){
      this.refreshPowerSankey();
    },
    lightbulbKfactor: function(newKfactor,oldKfactor){
      this.refreshPowerSankey();
    },
    hvacKfactor: function(newKfactor,oldKfactor){
      this.refreshPowerSankey();
    },
    windowKfactor: function(newKfactor,oldKfactor){
      this.refreshPowerSankey();
    },
    location: function(){
      this.getData();
    },
    baseYear: function(){
      this.getData();
    },
    usage: function() {
      this.getData();
    },
    buildingType: function() {
      // console.log(this.buildingType)
      this.getData();
    },
    grossArea: function() {
      this.refreshPowerSankey();
    }
  },
  computed: {
    energyData(){
      return this.epcData;
    },
    startDate(){
      return this.$store.state.startDate;
    },
    startDateInd(){
      return this.$store.state.startDateInd;
    },
    endDate(){
      return this.$store.state.endDate;
    },
    endDateInd(){
      return this.$store.state.endDateInd;
    },
    selectedTimes(){
      return this.$store.state.selectedTimes;
    },
    solarArraySize(){
      return this.$store.state.energy.solarArraySize;
    },
    solarArrayKfactor(){
      let degradationRate = 0.005; //0.5% year to year
      let compoundedDegradation = 1;
      // console.log(this.baseYear)
      if (this.baseYear > 2020){
        compoundedDegradation = Math.pow((1-degradationRate),(this.baseYear - 2020));
        // console.log( (1-degradationRate)^(this.baseYear - 2017))
        console.log(compoundedDegradation)
      }
      return compoundedDegradation*this.$store.state.energy.kFactors.solarArraySize;
    },
    lightbulbName(){
      return this.$store.state.energy.lightbulb;
    },
    lightbulbKfactor(){
      return this.$store.state.energy.kFactors.lightbulb;
    },
    hvacName(){
      return this.$store.state.energy.hvac;
    },
    hvacKfactor(){
      return this.$store.state.energy.kFactors.hvac;
    },
    windowName(){
      return this.$store.state.energy.window;
    },
    windowKfactor(){
      return this.$store.state.energy.kFactors.window;
    },
    location(){
      return this.$store.state.building.location;
    },
    baseYear(){
      return this.$store.state.weather.baseYear;
    },
    usage(){
      return this.$store.state.building.usage;
    },
    buildingType(){
      return this.$store.state.building.buildingType;
    },
    grossArea(){
      return this.$store.state.building.grossArea;
    },
    filterData(){
      let filteredData = this.energyData.filter(
        data => new Date(data.DateTime) >= new Date(this.dateData[this.startDateInd]) && new Date(data.DateTime) <= new Date(this.dateData[this.endDateInd]+' 23:00:00')
        );
      filteredData = filteredData.filter(data => this.selectedTimes.includes(new Date(data.DateTime).getHours()))
      
      return filteredData;
    },
    dateData(){

      let dateData = [...new Set(this.energyData.map(({DateTime}) => new Date(DateTime).toISOString().substring(0, 10)))];
      if(dateData[dateData.length-1]=='12/31/1969'){
        dateData.pop();
      }

      return dateData;
    },
  },
  async mounted() {
    echarts.registerTheme('shine', shine)
    this.powerSankey = echarts.init(document.querySelector('#powerSankey'))
    await this.getData()
    // console.log(this.energyData)
    // this.powerSankey = echarts.init(this.$refs.powerSankey,'shine');

    // this.refreshPowerSankey();
    this.powerSankey.on('click',{seriesIndex: 0},this.toggleData);
    // below didn't work because the first event also triggered the 2nd & 3rd
    this.powerSankey.on('click',{name: 'Lighting'},this.toggleLighting);
    this.powerSankey.on('click',{name: 'Mechanical & Plumbing'},this.toggleMandP);
    this.powerSankey.on('click',{name: 'Plug'},this.togglePlug);
    _.debounce(this.onResize,100)();
  }
}
</script>
